export const getRandomString = () => {
  return Math.random().toString(36);
}
